/*
 * Stratus: keep the cart's free-shipping limit in the shopper's own currency.
 *
 * snippets/st-free-shipping-limit.liquid writes data-limit already converted (75 for the US in USD, 100 for Canada in
 * CAD). Palo Alto's CartItems.assignArguments multiplies it by Shopify.currency.rate again, which is how the old
 * CA$125 read as about US$91 in the US. This re-reads the limit without the rate after every assignArguments (page load
 * and each cart drawer refresh) and redraws the progress, so assets/theme.js stays stock.
 *
 * Loaded deferred right after theme.js (snippets/head.liquid), so cart-items is already defined and upgraded.
 */
(() => {
  const CartItems = customElements.get('cart-items');
  if (!CartItems || CartItems.prototype.stLimitInShopperCurrency) return;

  const fixLimit = (cart) => {
    if (!cart.cartMessage || cart.cartMessage.length === 0) return;
    cart.cartFreeLimitShipping = Number(cart.cartMessage[0].getAttribute('data-limit')) * 100;
    cart.updateProgress();
  };

  const assignArguments = CartItems.prototype.assignArguments;
  CartItems.prototype.assignArguments = function () {
    assignArguments.call(this);
    fixLimit(this);
  };
  CartItems.prototype.stLimitInShopperCurrency = true;

  document.querySelectorAll('cart-items').forEach(fixLimit);
})();
